module.exports = "/images/whatsapp-brands.png?cde90ca98dc21a9fa420072ac05baff1";